import { initializeApp } from "firebase/app";
import {  getAuth , 
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
GoogleAuthProvider,
signInWithPopup
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBQwmg3GMLHfJN9piw6V6GlIyiT4xjfq38",
  authDomain: "turo-app-aa40c.firebaseapp.com",
  projectId: "turo-app-aa40c",
  storageBucket: "turo-app-aa40c.appspot.com",
  messagingSenderId: "329584972911",
  appId: "1:329584972911:web:980a88825e616a4f54699a",
  measurementId: "G-1VNNP8766S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth =  getAuth(app);

export {auth ,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
 
}


const provider = new GoogleAuthProvider();

export const GoogleLogin=()=>{
  console.log('subhan');
  signInWithPopup(auth, provider)
  .then((result) => {
    // const credential = GoogleAuthProvider.credentialFromResult(result);
    // console.log(credential);
    // const token = credential.accessToken;
    const user = result.user;
    console.log(user);
  }).catch((error) => {
    
    // const errorCode = error.code;
    // const errorMessage = error.message;
    const credential = GoogleAuthProvider.credentialFromError(error);
    console.log(credential);

  });
}
